import { Container } from "@webmotors/ioc";
import { queryFn, queryKey } from "./common/react-query";

export type QueryApi = {
  queryFn: <T>(
    providerName: string,
    argumentsList?: any[]
  ) => ReturnType<typeof queryFn<T>>;
  queryKey: (
    providerName: string,
    argumentsList?: any[]
  ) => ReturnType<typeof queryKey>;
};

export function createApi(app: Container): QueryApi {
  return {
    queryFn: <T>(providerName: string, argumentsList: any[] = []) => {
      return queryFn<T>(app, providerName, argumentsList);
    },
    queryKey: (providerName: string, argumentsList: any[] = []) => {
      return queryKey(app, providerName, argumentsList);
    },
  };
}
